import { createWebHashHistory, createRouter, type Router } from "vue-router";
import { routes } from "./routes";

/**
 * Hash history so the SPA owns `#/…` while the host may own `/editor/<uuid>/`
 * (cloud) or a Tauri webview with no meaningful path. Desktop and web share
 * the same router factory.
 */
export function createShellRouter(): Router {
  const router = createRouter({
    history: createWebHashHistory(),
    routes,
  });

  router.beforeEach((to) => {
    if (typeof window === "undefined") return true;
    if (window.location.pathname.startsWith("/reader/") === false) return true;
    const name = typeof to.name === "string" ? to.name : "";
    if (
      name === "storyboard" ||
      name.startsWith("notes") ||
      name.startsWith("database") ||
      name.startsWith("trash") ||
      name === "search"
    ) {
      return { path: "/" };
    }
    return true;
  });

  return router;
}
